import { render } from "./AdminDashboard.vue?vue&type=template&id=711da055&scoped=true&ts=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=ts"
export * from "./AdminDashboard.vue?vue&type=script&lang=ts"

import "./AdminDashboard.vue?vue&type=style&index=0&id=711da055&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711da055"]])

export default __exports__